import SizesPicker from './SizesPicker';

export default SizesPicker;
